<script>
import ManageAllocationModalOverlayForm from '../ManageAllocationModalOverlayForm/ManageAllocationModalOverlayForm.vue';
import {mapState, mapActions} from 'vuex';

export default {
    components: {
        ManageAllocationModalOverlayForm
    },
    computed: {
        ...mapState({
            open: state => state.allocation.modal.overlay.open,
        }),
    },
    methods: {
        ...mapActions({
            toggleModalOverlay: 'allocation/toggleModalOverlay'
        })
    }
}
</script>

<template>
    <div class="manage-allocation-modal-overlay">
        <transition name="slide-in">
            <div v-if="open" class="manage-allocation-modal-overlay__content">
                <div class="manage-allocation-modal-overlay__header">
                    <div class="manage-allocation-modal-overlay__heading">
                        {{ $t('manageAllocationModalOverlay.header.heading') }}
                    </div>
                    <div class="manage-allocation-modal-overlay__toggle" @click="toggleModalOverlay">
                        <i class="fa fa-chevron-left"/>
                    </div>
                </div>
                <div class="manage-allocation-modal-overlay__body">
                    <manage-allocation-modal-overlay-form/>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationModalOverlay/ManageAllocationModalOverlay.vue